import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaWhatsapp,
} from "react-icons/fa6";
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import "../styles/Footer.css";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Company Info Section */}
        <div className="footer-column company-info">
          <Link to="/" className="footer-logo" onClick={scrollToTop}>
            <img src="/LHS-logo-rounded.png" alt="Laxmi Hospitality Services Logo" title="Laxmi Hospitality Services Brand Logo" loading="lazy"/>
            <span className="footer-company-name">
              Laxmi Hospitality Services{" "}
            </span>
          </Link>
          <p className="tagline">Catering with Passion & Serving with Heart</p>
          <p className="description">
            Founded in 2009, Laxmi Hospitality Services specializes in{" "}
            <strong>industrial catering</strong>, custom-tailored
            to each client's unique requirements. We proudly serve{" "}
            <strong>across India</strong> with a strong presence in{" "}
            <strong>5 States/UTs</strong> and <strong>16+ cities</strong>. Our
            expertise extends to <strong>25 client locations</strong>, serving
            over <strong>17500+ individuals</strong> daily.
          </p>
          <div className="social-links">
            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.instagram.com/laxmi_hospitality_services/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.linkedin.com/company/laxmi-hospitality-services/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn />
            </a>
            <a
              href="https://wa.me/919724982104"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
            >
              <FaWhatsapp />
            </a>
          </div>
        </div>

        {/* Our Presence Section */}
        <div className="footer-column footer-presence">
          <h3>Our Presence</h3>
          <ul>
             <li>
              <Link to="/resources" onClick={scrollToTop}>
                Resources
              </Link>
            </li>
            <li>
              <Link to="/clients/maharashtra" onClick={scrollToTop}>
                Maharashtra
              </Link>
            </li>
            <li>
              <Link to="/clients/daman" onClick={scrollToTop}>
                Daman
              </Link>
            </li>
            <li>
              <Link to="/clients/gujarat" onClick={scrollToTop}>
                Gujarat
              </Link>
            </li>
            <li>
              <Link to="/clients/andhra-pradesh" onClick={scrollToTop}>
                Andhra Pradesh
              </Link>
            </li>
            <li>
              <Link to="/clients/telangana" onClick={scrollToTop}>
                Telangana
              </Link>
            </li>
          </ul>
        </div>

        {/* Quick Links Section */}
        <div className="footer-column quick-links">
          <h3>Quick Links</h3>
          <ul>
            <li>
              <Link to="/aboutus" onClick={scrollToTop}>
                About Us
              </Link>
            </li>
            <li>
              <Link to="/journey" onClick={scrollToTop}>
                Our Journey
              </Link>
            </li>
            <li>
              <Link to="/services" onClick={scrollToTop}>
                Services
              </Link>
            </li>
            <li>
              <Link to="/clients" onClick={scrollToTop}>
                Clients
              </Link>
            </li>
            <li>
              <Link to="/ourteam" onClick={scrollToTop}>
                Our Team
              </Link>
            </li>
            <li>
              <Link to="/contactus" onClick={scrollToTop}>
                Contact Us
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact Now Section */}
        <div className="footer-column contact-now">
          <h3>Contact Now</h3>
          <ul>
            <li>
              <a
                href="https://www.google.com/maps/search/Evershine+Sapphire,+Above+SBI+Bank,+DP+Road+9,+Chandivali,+Powai,+Mumbai+-+400+072./"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Our Location"
              >
                <div className="icon-wrapper">
                  <FaMapMarkerAlt />
                </div>
              </a>
              <span>
                Evershine Sapphire, Above SBI Bank, DP Road 9, Chandivali,
                Powai, Mumbai - 400 072.
              </span>
            </li>
            <li>
              <div className="icon-wrapper">
                <FaPhoneAlt />
              </div>
              <div>
                <a href="tel:+919987558691" aria-label="Call Us">
                <span>+91 97249 82104</span>
                </a>
                <br />
                <a href="tel:+919812345678" aria-label="Call Us">
                  <span>+91 99875 58691</span>
                </a>
              </div>
            </li>

            <li>
              <a
                href="mailto:admin@laxmihospitalityservices.in"
                aria-label="Email Us"
              >
                <div className="icon-wrapper">
                  <FaEnvelope />
                </div>
              </a>
              <a href="mailto:laxmihospitalityservicesind@gmail.com">
                laxmihospitalityservicesind@gmail.com
              </a>
            </li>
          </ul>
          <div className="go-to-top-wrapper">
            <button className="go-to-top" onClick={scrollToTop}>
              Go to Top <span className="arrow-up">↑</span>
            </button>
          </div>
        </div>
      </div> {/* end of .footer-container */}

      <div className="footer-meta-row">
        <div className="footer-attribution-left">
          Designed &amp; Developed  by{" "}
          <a
            href="https://www.linkedin.com/in/balajis183/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Balaji S
          </a>
          {" & "}
          <a
            href="https://www.linkedin.com/in/manikanta-vaddi-2352b0287/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Manikanta Vaddi
          </a>
        </div>
        <div className="footer-copyright-right">
          © {new Date().getFullYear()} Laxmi Hospitality Services | All rights reserved
        </div>
      </div>
    </footer>
  );
};

export default Footer;
